import styled from 'styled-components';
import {theme} from '@styles/theme';

export const CoverageTestBlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  border: 2px solid ${theme.colors.basic06};
  border-radius: ${theme.roundedMedium};
  padding: 8px;
`;

export const CoverageTestChartWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border: 1px solid ${theme.colors.basic05};
  border-radius: 80px;
  padding: 3px;
  background-color: ${theme.colors.basic08};
`;

export const CoverageTestFullText = styled.div`
  position: absolute;
`;
